'use strict';

const _ = {
    assign: require('lodash/assign'),
    includes: require('lodash/includes'),
};

const React = require('react');
const PropTypes = require('prop-types');
const uuid = require('uuid');

const Strings = require('../../../../../app/shared/Strings');

const ImgPortrait = require('./ImgPortrait');
import VoiceStore from '../../../stores/VoiceStore';
import VoiceActions from '../../../actions/VoiceActions';

class AvatarSelect extends React.Component {
    
    constructor(props) {
        super(props);
        var charImages = MZLAvatarLibrary.getPlayerHashes();
        var activeElem = charImages.indexOf(props.defaultAvatarHash);
        if (activeElem < 0) {
            activeElem = 0; // default to first portrait if we don't recognize the hash
        }
        
        this.state = {
            playerName: props.defaultPlayerName,
            imgHash: charImages[activeElem],
            activeElem,
            options: VoiceStore.getState().options,
        };
    }

    onNameChange=(e)=>{
        let playerName = e.target.value;
        this.setState({
            playerName,
            nameChanged: true
        });
        if (this.props.onNameChange) {
            this.props.onNameChange(playerName);
        }
    }

    onSelectPortrait=(imgHash)=>{
        var charImages = MZLAvatarLibrary.getPlayerHashes();
        var activeElem = charImages.indexOf(imgHash);
        this.setState({
            imgHash: imgHash,
            activeElem: activeElem
        });
    }

    onPlay=()=>{
        let name = this.state.playerName || this.props.defaultPlayerName;
        this.props.setPlayerNameAndHash(name,this.state.imgHash);
    }

    onKeyDown=(e)=>{
        var activeElem = this.state.activeElem || 0;
        var charImages = MZLAvatarLibrary.getPlayerHashes();

        if (e.key == 'ArrowUp' || e.key == 'ArrowLeft') {
            activeElem--;
        } else if (e.key == 'ArrowDown' || e.key == 'ArrowRight') {
            activeElem++;
        }

        if (activeElem < 0) {
            activeElem = 0;
        } else if (activeElem >= charImages.length) {
            activeElem = charImages.length - 1;
        }

        if (e.key == 'ArrowUp' || e.key == 'ArrowLeft' || e.key == 'ArrowDown' || e.key == 'ArrowRight') {
            this.setState({activeElem: activeElem},()=>{
                var imgHash = charImages[activeElem];
                if (imgHash) {
                    $('#img-'+imgHash).focus();
                }
            });
        }
    }
        
    setVoiceEnabled=(e)=>{
        let disabled = !e.target.checked;
        let options = {...this.state.options, disabled };
        this.setState({options},()=>{
            this.updateVoiceOptions();
        });
    }
    
    updateVoiceOptions=()=>{
        VoiceActions.setVoiceOptions(uuid.v4(),this.state.options);
    }
        
	render() {
        var charImages = MZLAvatarLibrary.getPlayerHashes();
        var placeholderName = this.props.defaultPlayerName || 'Enter Name';
        var selectedInPool = _.includes(charImages,this.state.imgHash);
        let { volume, disabled } = this.state.options;

        let channelWidth = this.props.channelWidth || '1rem';
        
        return (
            <div className="avatar-select-prompt" style={{top: channelWidth}}>
                <div className="fsp-content" role="main" aria-labelledby={"avatar-prompt"} >
                    <div className="context-description">
                        {this.props.avatarPromptText}
                    </div>
                    <div className="player-info">
                        <div className="player-portrait">
                            <ImgPortrait portraitID={this.state.imgHash} />
                        </div>
                        <div className="player-name-container">
                            <label htmlFor="char-name-input">
                                {this.props.playerNameLabel}
                            </label>
                            <div>
                                <input type="text" id="char-name-input" 
                                    onChange={this.onNameChange} 
                                    value={this.state.nameChanged ? this.state.playerName : ''} 
                                    size="30" 
                                    maxLength="25" 
                                    placeholder={placeholderName}/>
                            </div>
                        </div>
                    </div>
                    
                    <div className="player-image-select" onKeyDown={this.onKeyDown} role="radiogroup" tabIndex={-1}>
                        {charImages.map((imgHash,index)=>{
                            var tabIdx = this.state.activeElem === index ? 0 : -1;
                            if (!selectedInPool && index === 0) {
                                tabIdx = 0;
                            }
                            var selected = imgHash == this.state.imgHash;
                            var customAltText; // purposely undefined
                            let entry = MZLAvatarLibrary.getAvatar(imgHash)
                            if (entry && entry.altText) {
                                customAltText = entry.altText;
                            }
                            return (
                                <div className="portrait-container" key={index}>
                                    <div className={"avatar-portrait" + (selected ? " selected" : "")} >
                                        <span>
                                            <ImgPortrait key={imgHash} 
                                                portraitID={imgHash}
                                                imageDesc={customAltText}
                                                id={'img-'+imgHash} 
                                                tabIndex={tabIdx} 
                                                role="radio"
                                                selected={selected}
                                                onSelect={this.onSelectPortrait.bind(this,imgHash)}
                                                onKeyDown={this.onKeyDown}
                                                />
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    
                    { this.props.showVoiceOptions ? 
                    <div className="voice-controls">
                        <input id="npc-voice-enable-disable" type="checkbox" checked={!disabled} onChange={this.setVoiceEnabled}/>
                        <label htmlFor="npc-voice-enable-disable">{Strings["en"].voice_options.NPC_VOICE_ENABLED}</label>
                    </div>
                    : null }
                    
                    <div className="button-container">
                        <button className="btn btn-primary continue" onClick={this.onPlay}>{this.props.playButtonText}</button>
                    </div>
                </div>
            </div>

        );
    }
};

AvatarSelect.propTypes = {
    setPlayerNameAndHash: PropTypes.func.isRequired,
    playButtonText: PropTypes.string,
    defaultPlayerName: PropTypes.string,
    defaultAvatarHash: PropTypes.string,
    playerNameLabel: PropTypes.string,
    avatarPromptText: PropTypes.string,
    showVoiceOptions: PropTypes.bool,
};

AvatarSelect.defaultProps = {
    playButtonText: 'Continue',
    defaultPlayerName: 'Player',
    defaultAvatarHash: '',
    playerNameLabel: 'Player Name',
    avatarPromptText: "To begin, enter your name, select an avatar image, and press continue.",
};

module.exports = AvatarSelect;
